<!--
   Created by qing on 2020/12/19
   Des: 
-->
<template>

  <van-popup
    class="node-detail-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="node-detail-popup-content">
      <div v-if="loadingEnd" class="node-detail-container">

        <template v-if="nodeInfo">

          <div style="margin-top: 10px">
            <van-field label="标题">
              <template #input>
                <div>
                  {{nodeInfo.nodeName}}
                </div>
              </template>
            </van-field>
            <van-field label="内容">
              <template #input>
                <div class="remark ql-editor" v-html="nodeInfo.nodeContent">
                </div>
              </template>
            </van-field>

            <div class="file-container">
              <ul class="file__list">
                <li v-for="(file, idx) in nodeInfo.attachmentList">
                  <div class="file__icon">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                    </svg>
                  </div>
                  <div class="file__info">
                    <div class="file__info-name">
                      {{file.fileName}}
                    </div>
                    <div class="file__info-bottom">

                      <div class="file__info-size">
                        {{file.fileSize}}KB
                      </div>
                      <div class="file__info-handle">
                        <div
                          class="handle-button"
                          @click.stop.prevent.left="previewFile(file)">
                          预览
                        </div>
                        <div class="divider"></div>
                        <div
                          class="handle-button"
                          @click.stop.prevent.left="downloadFile(file)">
                          下载
                        </div>
                        <div class="divider"></div>
                        <div
                          v-if="[nodeInfo.userId, nodeInfo.chargeUser].includes($store.getters.userId)"
                          class="handle-button"
                          @click="openFileAccessRecords(file.fileUrl)">
                          访问记录
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <van-field label="创建时间">
              <template #input>
                <div>
                  {{actionFormatTime(nodeInfo.createTime)}}
                </div>
              </template>
            </van-field>
            <van-field label="创建人">
              <template #input>
                <div v-if="$store.getters.userListMap[nodeInfo.userId]">
                  {{$store.getters.userListMap[nodeInfo.userId].nickname}}
                </div>
              </template>
            </van-field>
          </div>

          <div style="margin-top: 10px; background-color: #fff">
            <comment-container
              ref="commentContainer"
              :commentList="commentList"
              :stackList="stackList"
              @replyComment="replyComment"
              @editComment="editComment"
              @onClickComment="onClickComment"
            ></comment-container>
          </div>
        </template>

        <empty v-else></empty>

      </div>
      <div class="comment-input">
        <comment-input
          v-if="nodeInfo"
          ref="commentInput"
          :nodeId="nodeInfo.nodeId"
          :mixFormId="mixFormId"
          commentType="NODE"
          :fetchSourceContent="fetchSourceContent"
          @focusComment="focusComment"
          @submitCommentComplete="submitComment"
        ></comment-input>
      </div>

      <!--评论回复列表-->
      <CommentReplyList
        v-if="nodeInfo"
        ref="commentReplyList"
        :nodeId="nodeInfo.nodeId"
        :mixFormId="mixFormId"
        :stackList="stackList"
        commentType="NODE"
        @reply-close="replyListClose"
      ></CommentReplyList>

      <!--访问记录-->
      <file-access-records
        ref="fileAccessRecords"
        :stackList="stackList"
      ></file-access-records>

      <file-preview-popup
        ref="filePreviewPopup"
        :stackList="stackList"
      ></file-preview-popup>
    </div>

  </van-popup>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText, clone} from "../../../assets/js/Untis";
  import CommentContainer from "./CommentContainer";
  import CommentInput from "./CommentInput";
  import CommentReplyList from "./CommentReplyList";
  import FileAccessRecords from "./FileAccessRecords";
  import FilePreviewPopup from "./FilePreviewPopup";

  export default {
    props: {
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      CommentContainer,
      CommentInput,
      CommentReplyList,
      FileAccessRecords,
      FilePreviewPopup
    },
    data() {
      return {

        visibleInfo: {
          nodeId: '',
          visible: false
        },
        loadingEnd: false,
        nodeId: '',
        nodeInfo: null,
        downloadEle: null,
        commentList: []
      }
    },
    created() {
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
    },
    computed: {
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      open(nodeId) {
        this.loadingEnd = false
        this.nodeId = nodeId
        this.visibleInfo.nodeId = nodeId
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true

        this.$store.dispatch('actionMixFormNodeDetail', {
          mixFormId: this.mixFormId,
          nodeId: nodeId
        }).then(res => {
          this.nodeInfo = res
        }).catch(console.error)
          .finally(() => {
            this.loadingEnd = true
          })
        this.fetchCommentList()
      },

      beforeClose() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.close()
        }
        if (this.$refs.commentReplyList) {
          this.$refs.commentReplyList.close()
        }
        this.$emit('close')
      },
      fetchCommentList() {
        this.$store.dispatch('actionCommentList', {
          mixFormId: this.mixFormId,
          nodeId: this.nodeId,
          commentType: 'NODE'
        }).then(res => {
          this.commentList = res
        }).catch(console.error)
      },

      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
        this.downloadEle.click()
      },
      previewFile(file) {

        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
        }

      },

      // 获取回复的评论
      fetchSourceComment(commentId) {
        return this.commentList.filter(comment => comment.commentId === commentId)[0]
      },
      // 获取回复的评论的字符串内容
      fetchSourceContent(commentId) {
        const comment = this.fetchSourceComment(commentId)
        if (!comment) {
          return ''
        }
        let content = getSimpleText(comment.content)
        content += comment.content.includes('<img') ? '【图片】' : ''
        content += comment.content.includes('<video') ? '【视频】' : ''
        if (!content) {
          if (comment.attachmentList && comment.attachmentList.length) {
            content = '【附件】'
          }
        }
        return content
      },

      // 首次填写评论
      focusComment() {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'NONE'
          })
        }
      },

      // 回复评论
      replyComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'REPLY',
            replyCommentInfo: item
          })
        }
      },
      // 编辑评论
      editComment(item) {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.open({
            commentStatus: 'EDIT',
            commentInfo: clone(item)
          })
        }
      },
      // 点击评论
      onClickComment(item) {
        if (item.replyId && this.$refs.commentReplyList) {
          this.$refs.commentReplyList.open({
            commentId: item.commentId,
            rootId: item.rootId
          })
        }
      },
      // 发表评论完成
      submitComment({commentStatus, commentInfo}) {
        if (commentStatus === 'EDIT') {
          const comment = this.commentList.filter(comment => comment.commentId === commentInfo.commentId)[0]
          if (comment) {
            comment.content = commentInfo.content
            comment.attachmentList = commentInfo.attachmentList
          }
        } else {
          this.commentList.unshift(commentInfo)
        }
      },

      // 回复列表关闭，需要刷新一下评论列表
      replyListClose() {
        this.fetchCommentList()
      },

      openFileAccessRecords(fileUrl) {
        if (this.$refs.fileAccessRecords) {
          this.$refs.fileAccessRecords.open(fileUrl)
        }
      },
    }
  }
</script>

<style lang="less">

  .node-detail-popup {
    background-color: #F6F6F6 !important;

    .node-detail-popup-content {
      width: 100%;
      height: calc(100% - env(safe-area-inset-bottom));
      position: relative;
      overflow: hidden;

      .node-detail-container {
        position: absolute;
        top: 0;
        bottom: calc(50px + env(safe-area-inset-bottom));
        left: 0;
        right: 0;
        overflow: auto;

        .file-container {
          background-color: #fff;
          border-bottom: 1px solid #e6e6e6;
          padding: 0 20px;
        }

        .van-field__value {
          width: calc(100% - 60px);
        }
      }

      .comment-input {
        position: absolute;
        height: 50px;
        bottom: calc(env(safe-area-inset-bottom));
        left: 0;
        right: 0;
      }
    }

    .van-field__label {
      width: 60px;
      font-size: 13px;
    }

    .van-field__value {
      font-size: 13px;
    }

    .remark {
      overflow: hidden;
      height: fit-content;
      width: 100%;
      padding: 10px;
      font-size: 12px;
      color: #333;


      img, video {
        max-width: 100%;
      }
    }

  }
</style>